// TODO un poco ñapilla, a quién vamos a engañar
export const createPoiOverlayFeatureId = (poiId: number | string) =>
  `poi_${poiId}`;

export const getPoiIdFromPoiOverlayFeatureId = (featureId: string) => {
  if (featureId?.includes("poi_")) {
    return parseInt(featureId.replace("poi_", ""), 10);
  }
  return undefined;
};
